<template>
  <Container type="card-full" v-loading="loading">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">协议编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectptccode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">交易结果</div>
          <div class="field">
            <el-select
              v-model="query.failproject"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in failProjectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目员</div>
          <div class="field">
            <el-input
              v-model.trim="query.projectCusername"
              clearable
            ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">业务员</div>
          <div class="field">
            <el-input v-model.trim="query.ptcUsername" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">归档状态</div>
          <div class="field">
            <el-select
              v-model="query.status"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in pdsstausList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              v-if="+query.comtype === 1"
              type="primary"
              @click="showButton = !showButton"
              >{{ showButton ? "收起" : "展开" }}</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-collapse-transition v-if="+query.comtype === 1">
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPdslList">
              <el-radio-button
                v-for="item in this.areaList"
                :key="item.dptareacode"
                :label="item.dptareacode"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <vggrid
      :list="list"
      tableheight="600"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :defaultPage="10"
      :total="query.total"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
      @pagechange="pagechange"
      :isOperate="btn.isOperate"
      :operateBtn="btn.right"
      @vggridClick="vggridClick"
    >
      <template slot="btn">
        <menu-btn
          :menuid="menuid"
          @btnClick="btnClick"
          @btnmenuclick="btnmenuclick"
        ></menu-btn>
        <div
          style="float: left; line-height: 41.5px"
          v-if="+this.$store.getters.loginUser.comtype != 3"
        >
          <!-- 【项目预算合计】：{{ amt.price_gdprice | Thousands }}元 -->
        </div>
      </template>
    </vggrid>
  </Container>
</template>

<script>
import _ from "lodash";
import common from "@/mixin/common";
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import utils from "../../assets/js/utils";

export default {
  name: "xmgd",
  mixins: [common],
  data() {
    return {
      pdsstausList: [], //状态
      pds: {},
      list: [],
      btn: {},
      loading: false,
      areaList: [],
      areaid: 0,
      amt: {},
      showButton: true,
      menuid: this.$route.query.menuid,
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        total: 0,
        limit: 10,
        offset: 0,
      },
      failProjectStatusList: [],
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "projectcode",
          fieldtype: "C",
          title: "项目编号",
          calculExpr: "",
          addNewRowFlg: false,
          width: 100,
        },
        {
          field: "projectptccode",
          fieldtype: "C",
          title: "协议编号",
          calculExpr: "",
          addNewRowFlg: false,
          width: 100,
        },
        {
          field: "projectname",
          fieldtype: "C",
          title: "项目名称",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "采购人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "prsflgdesc",
          fieldtype: "C",
          title: "交易方式",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "projecttime",
          fieldtype: "T",
          title: "建项时间",
          calculExpr: "",
          addNewRowFlg: false,
          formatter: ["toDateString", "yyyy-MM-dd"],
          width: 100,
        },
        {
          field: "projectresultdesc",
          fieldtype: "C",
          title: "交易结果",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "projectsusername",
          fieldtype: "C",
          title: "业务员",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "projectcuserneme",
          fieldtype: "C",
          title: "项目员",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "pdscheckusername",
          fieldtype: "C",
          title: "档案员",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "pdschecktime",
          fieldtype: "T",
          title: "归档时间",
          calculExpr: "",
          addNewRowFlg: false,
          formatter: ["toDateString", "yyyy-MM-dd"],
          width: 100,
        },
        {
          field: "pdsstausname",
          fieldtype: "C",
          title: "状态",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          width: 100,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              // //  onClick={this.showdownFild.bind(this, row)}
              // let btnName = ''
              // if((+row.pdsstaus === 1 || !row.pdsstaus) && +this.$store.getters.loginUser.roletype !== 5)
              //   btnName='申请'
              // else if(+row.pdsstaus === 2 && +this.$store.getters.loginUser.roletype === 5)
              //   btnName='归档'
              // else
              //   btnName='查阅'
              // // 查阅
              //   return [<vxe-button type='primary' onClick={this.toXmglFrom.bind(this, row)}>{btnName}</vxe-button>]
              if (+this.$store.getters.loginUser.rolecomtype === 2) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.ViewFile.bind(this, row)}
                  >
                    查档
                  </vxe-button>,
                ];
              } else if (+this.$store.getters.loginUser.roletype === 6) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.ViewFile.bind(this, row)}
                  >
                    查档
                  </vxe-button>,
                ];
              } else if (
                (+row.pdsstaus === 1 || !row.pdsstaus) &&
                row.pdscheckuserid
              ) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.saveFile.bind(this, row)}
                  >
                    重新申请
                  </vxe-button>,
                ];
              } else if (
                (+row.pdsstaus === 1 || !row.pdsstaus) &&
                +this.$store.getters.loginUser.roletype !== 5
              ) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.saveFile.bind(this, row)}
                  >
                    申请
                  </vxe-button>,
                ];
              } else if (
                +row.pdsstaus === 2 &&
                +this.$store.getters.loginUser.roletype === 5
              ) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.toXmglFrom.bind(this, row)}
                  >
                    归档
                  </vxe-button>,
                ];
              } else if (
                +row.pdsstaus === 2 &&
                +this.$store.getters.loginUser.roletype !== 5
              ) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.ViewPdsFile.bind(this, row)}
                  >
                    查档
                  </vxe-button>,
                ];
              } else {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.ViewPdsFile.bind(this, row)}
                  >
                    查档
                  </vxe-button>,
                ];
              }
            },
          },
        },
      ],
    };
  },
  async created() {},
  mounted() {},
  async activated() {
    await this.getPdsstausList();
    await this.getPdslList();
    await this.getfailProjectStatusList();
    if (this.query.comtype === 1) {
      this.getareaList();
    }
  },
  components: { MenuBtn, vggrid },
  computed: {},
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  methods: {
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.pds = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async cellClick(row) {
      this.pds = row.row;
    },
    async getfailProjectStatusList() {
      this.failProjectStatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "failproject" },
      });
    },
    async viewProject(row) {
      this.pds = row.row;
      this.$router.push({
        name: "xmgdView",
        params: { projectid: row.row.projectid, type: 1 },
      });
    },
    async search() {
      this.query.offset = 0;
      await this.getPdslList();
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPdslList();
    },
    async getPdsstausList() {
      //获取下拉列表
      let res = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "pdsstaus" },
      });
      if (+this.$store.getters.loginUser.roletype === 5)
        res = res.filter((e) => {
          return e.value != 1;
        });
      this.pdsstausList = res;
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
    async getPdslList() {
      this.query.selectField = `projectcode,projectptccode,projectname,projecttime,projectid,projectstatus,prsflg,projectptcid,projectcosid`;
      if (+this.$store.getters.loginUser.roletype === 5) {
        this.query.usertype = 5;
      }
      this.query.areaid = this.areaid;
      let res = await request({
        url: "/xmgl/pds/getpdslList",
        method: "get",
        params: this.query,
      });
      res.list.map((e) => {
        e.projectresultdesc = e.projectresult > 0 ? "成功" : "失败";
        if (e.pdsstaus !== 3) {
          e.pdscheckusername = " ";
          e.pdschecktime = null;
        }
      });
      this.list = res.list;
      this.query.total = res.count[0].count;
      // this.amt = res.amt ? res.amt[0] : {};
    },
    async toXmglFrom(row) {
      this.pds = row;
      let temType;
      if (+row.prsflg === 1 || +row.prsflg === 3) {
        temType = 1;
      } else if (+row.prsflg === 6) {
        temType = 2;
      } else {
        temType = 3;
      }
      if (
        (+row.pdsstaus === 1 || !row.pdsstaus) &&
        +this.$store.getters.loginUser.roletype !== 5
      )
        this.$router.push({
          name: "xmgdFrom",
          params: { projectid: row.projectid, type: 1, temType: temType },
        });
      else if (
        +row.pdsstaus === 2 &&
        +this.$store.getters.loginUser.roletype === 5
      )
        this.$router.push({
          name: "xmgdFrom",
          params: { projectid: row.projectid, type: 1, temType: temType },
        });
      else
        this.$router.push({
          name: "xmgdView",
          params: { projectid: row.projectid, type: 1, temType: temType },
        });
    },
    async saveFile(row) {
      let temType;
      if (+row.prsflg === 1 || +row.prsflg === 3) {
        temType = 1;
      } else if (+row.prsflg === 6) {
        temType = 2;
      } else {
        temType = 3;
      }
      let model = {};
      model.projectid = row.projectid;
      model.pdsprs = temType;
      model.cosid = +this.$store.getters.loginUser.cosid;
      model.pdsstaus = 1;
      model.pdscreateuserid = +this.$store.getters.loginUser.userid;

      this.loading = true;
      let pdsList = await request({
        url: "/xmgl/pds/searchhavePdsList",
        method: "get",
        params: model,
      });
      if (pdsList.length > 0) {
        this.loading = false;
        this.toXmglFrom(row);
      } else {
        let res = await request({
          url: "/xmgl/pds/insertPds",
          method: "post",
          data: model,
        });
        this.loading = false;
        if (res.issuccess === 1) this.toXmglFrom(row);
      }
    },
    async ViewFile(row) {
      if (+row.pdsstaus >= 2) {
        let { href } = this.$router.resolve({
          name: "archives",
          query: {
            projectid: row.projectid,
            ptcid: row.projectptcid,
            projectcode: row.projectcode,
            cosid: row.projectcosid,
          },
        });
        window.open(href, "_blank");
      } else {
        this.$message.warning("还未归档");
        return;
      }
    },
    async ViewPdsFile(row) {
      if (+row.pdsstaus >= 2) {
        let { href } = this.$router.resolve({
          name: "archives",
          query: {
            projectid: row.projectid,
            ptcid: row.projectptcid,
            projectcode: row.projectcode,
            cosid: row.projectcosid,
          },
        });
        window.open(href, "_blank");
      } else {
        await this.toXmglFrom(row);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
